// IE and Edge do not preserve focus order when elements are deleted.
// Requirements 7336, 7293, 7340
import focusableEls from '../focusable-elements';
import { isLegacyEdge } from '@cognitoforms/utils/user-agent';

export default {
	methods: {
		recordFocus() {
			if (!isLegacyEdge(window.navigator))
				return false;

			let focusIndex;
			const elements = [...this.$root.$el.querySelectorAll(focusableEls)];

			elements.forEach(function(element, i) {
				if (element === document.activeElement)
					focusIndex = i;

				// Remove any hidden elements from list
				if (element.getBoundingClientRect().width === 0)
					elements.splice(i, 1);
			});
			this.$emit('focus-removed', { focusIndex, elements });
		}
	}
};